module.exports = __webpack_public_path__ + "static/media/twitter.18d679b6.bmp";